// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__6oCpw","cloudCard":"Cards_cloudCard__3BDeu","clockCard":"Cards_clockCard__tO_nN","lockCard":"Cards_lockCard__Myphe","mapCard":"Cards_mapCard___5lLI"};